import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { ref } from "vue";
import { PpDraw } from "../model/draw";
import { fetchDraw, fetchSpecialPrizeResults, fetchSpecialPrizeResultsCount } from "./api";

const results = ref<PpDraw | null>(null);

export const fetch = async (lottery: Lottery, id: number) => {
    results.value = await fetchDraw(lottery, id);
};

export const fetchSpecialPrize = async (
    lottery: Lottery,
    prizeType: string,
    pageNumber: number,
    codeFilter?: string
) => {
    return await fetchSpecialPrizeResults(lottery, results.value.drawId, prizeType, pageNumber, codeFilter);
};

export const fetchSpecialPrizeCount = async (lottery: Lottery, codeFilter?: string) => {
    return await fetchSpecialPrizeResultsCount(lottery, results.value.drawId, codeFilter);
};

export const useLotteryResults = () => ({
    results,
    fetch,
    fetchSpecialPrize,
    fetchSpecialPrizeCount,
});
